import { render, staticRenderFns } from "./PageSupplier.vue?vue&type=template&id=0c6be926&scoped=true"
import script from "./PageSupplier.vue?vue&type=script&lang=js"
export * from "./PageSupplier.vue?vue&type=script&lang=js"
import style0 from "./PageSupplier.vue?vue&type=style&index=0&id=0c6be926&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6be926",
  null
  
)

export default component.exports